<div class="center">
    <div class="circle">
        <div class="checkmark"></div>
      </div>
    <p class="congrats">Congratulations!</p>
    <p>Application for permit  has been <span *ngIf="isAdmin">updated</span> <span *ngIf="!isAdmin">created</span> successfully. </p>
    <p>You can go to ‘My applications’ to create another application or you can view your permit</p>

    <button class="btn btn-success" (click)="landing()" *ngIf="!isAdmin">View applications</button>
    <button class="btn btn-success" (click)="applicationList()" *ngIf="isAdmin">View my applications</button>
  </div>

